module.exports = __webpack_public_path__ + "img/serve_banner.eb6a2eae.jpg";